import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    FiveInfoProgramIndividu,
    FiveRincianPembayaranIndividu,
    FiveMetodePembayaranIndividu,
    FiveSummaryMobIndividu,
    FiveSummaryWebIndividu,
    FiveInfoProgramCorporate,
    FiveRincianPembayaranCorporate,
    FiveMetodePembayaranCorporate,
    FiveSummaryMobCorporate,
    FiveSummaryWebCorporate
} from '../../';
import useFetchUserByToken from '../../../../hooks/useFetchUserByToken'

const FormKatalogProgramFive = () => {

    const user = useFetchUserByToken()

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)
    const categoryUser = useSelector(state => state.categoryUserSelected)
    const programSelected = useSelector(state => state.programSelected)
    const scheduleSelected = useSelector(state => state.scheduleSelected)
    const participants = useSelector(state => state.participants)

    const bpSelected = useSelector(state => state.bpSelected)
    const bpScheduleSelected = useSelector(state => state.bpScheduleSelected)
    const bpParticipants = useSelector(state => state.bpParticipants)


    const handleChangeFormInput = (key, e) => {
        dispatch({ type: key, 'value': e.target.value });
    }

    // console.log(dataInputRegistration)

    return (
        <>
            <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Konfirmasi Data Pendaftaran</h3>
                <hr style={{ marginBottom: '2%', marginTop: '2%' }}></hr>
                <div className='row mb-2'>
                    <p style={{ fontSize: size.width < 500 ? '12px' : '16px', marginBottom: '2%', fontWeight: '400' }}>Apakah Data Anda Sudah Sesuai?</p>
                    <div className='row' style={{ marginLeft: '5px', marginTop: size.width < 500 ? '10%' : '0%' }}>
                        <h5 style={{ color: '#26D07C', marginBottom: '2%', fontSize: '16px', fontWeight: '700' }}>Informasi Data PIC</h5>
                        <div className='col-lg-12'>
                            <label className="form-label" style={{ color: '#5E6278', fontSize: size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Sumber Informasi</label>
                            <p style={{ color: '#191919', fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{user.user.informationSource}</p>
                            <hr className='mt-0'></hr>
                        </div>
                        <div className='col-lg-12'>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <label className="form-label" style={{ color: '#5E6278', fontSize: size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nama PIC</label>
                                    <p style={{ color: '#191919', fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{user.user.firstName} {user.user.lastName}</p>
                                </div>
                                <div className='col-lg-6'>
                                    <label className="form-label" style={{ color: '#5E6278', fontSize: size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Nomor Handphone</label>
                                    <p style={{ color: '#191919', fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{user.user.mobilePhone}</p>
                                </div>
                            </div>
                            <hr className='mt-0'></hr>
                        </div>
                        <div className='col-lg-12'>
                            <label className="form-label" style={{ color: '#5E6278', fontSize: size.width < 500 ? '12px' : '14px', fontWeight: '500' }}>Email</label>
                            <p style={{ color: '#191919', fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '600' }}>{user.user.email}</p>
                            <hr className='mt-0'></hr>
                        </div>
                    </div>
                    {
                        categoryUser.value === 'individual' ?
                            <>
                                <FiveMetodePembayaranIndividu
                                    categoryUser={categoryUser}
                                    dataInputRegistration={dataInputRegistration}
                                    size={size}
                                />
                                <FiveInfoProgramIndividu
                                    programSelected={programSelected}
                                    scheduleSelected={scheduleSelected}
                                    bpSelected={bpSelected}
                                    bpScheduleSelected={bpScheduleSelected}
                                    dataInputRegistration={dataInputRegistration}
                                    size={size}
                                />
                                <FiveRincianPembayaranIndividu
                                    programSelected={programSelected}
                                    scheduleSelected={scheduleSelected}
                                    bpSelected={bpSelected}
                                    bpScheduleSelected={bpScheduleSelected}
                                    size={size}
                                    participants={participants}
                                    bpParticipants={bpParticipants}
                                />
                                {
                                    size.width < 500 ?
                                        <FiveSummaryMobIndividu
                                            programSelected={programSelected}
                                            bpSelected={bpSelected}
                                            size={size}
                                        />
                                        :
                                        <FiveSummaryWebIndividu
                                            programSelected={programSelected}
                                            bpSelected={bpSelected}
                                            size={size}
                                        />
                                }
                            </>
                            :
                            <>
                                <FiveMetodePembayaranCorporate
                                    categoryUser={categoryUser}
                                    dataInputRegistration={dataInputRegistration}
                                    size={size}
                                />
                                <FiveInfoProgramCorporate
                                    programSelected={programSelected}
                                    scheduleSelected={scheduleSelected}
                                    participants={participants}
                                    bpSelected={bpSelected}
                                    bpScheduleSelected={bpScheduleSelected}
                                    bpParticipants={bpParticipants}
                                    size={size}
                                />
                                <FiveRincianPembayaranCorporate
                                    programSelected={programSelected}
                                    scheduleSelected={scheduleSelected}
                                    participants={participants}
                                    bpSelected={bpSelected}
                                    bpScheduleSelected={bpScheduleSelected}
                                    bpParticipants={bpParticipants}
                                    size={size}
                                />

                                {
                                    size.width < 500 ?
                                        <FiveSummaryMobCorporate
                                            programSelected={programSelected}
                                            size={size}
                                            participants={participants}
                                            bpSelected={bpSelected}
                                            bpParticipants={bpParticipants}
                                        />
                                        :
                                        <FiveSummaryWebCorporate
                                            programSelected={programSelected}
                                            size={size}
                                            participants={participants}
                                            bpSelected={bpSelected}
                                            bpParticipants={bpParticipants}
                                        />
                                }
                                <div className='row' style={{ marginLeft: '5px', marginTop: size.width < 500 ? '10%' : '2%' }}>
                                    <div className='col-lg-12' style={{ backgroundColor: '#FFF3CD' }}>
                                        <p style={{ fontSize: size.width < 500 ? '12px' : '16px', marginTop: '2%', marginBottom: '2%', fontWeight: '700' }}>Billing Requirement</p>
                                        <p style={{ fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '400' }}>Berikut ini dokumen standard yang kami lampirkan dalam invoice</p>
                                        <ul style={{ fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '400' }}>
                                            <li>Attendance List</li>
                                            <li>Dokumentasi Foto</li>
                                            <li>Invoice</li>
                                            <li>Faktur Pajak</li>
                                            <li>E-Nofa</li>
                                        </ul>
                                        <p style={{ fontSize: size.width < 500 ? '12px' : '15px', fontWeight: '400' }}>Jika anda membutuhkan dokumen selain di atas, silahkan isi disini :</p>
                                        <input style={{ marginBottom: '2%' }} type='text' className='form-control' placeholder='...' onChange={(e) => handleChangeFormInput('SET_DOKUMEN_REQUIREMENT_LAINNYA', e)} value={dataInputRegistration.dokumenRequirementLainnya} />
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </div>
        </>
    )
}

export default FormKatalogProgramFive
